import { supportedLang } from "./default";

//https://www.leohuynh.dev/snippets/casing-utils/
export function pascalCaseToPlainText(str: string): string {
  return str.replace(/[A-Z]/g, ($1) => ` ${$1.toLowerCase()}`).trim();
}

export const transparentPixel = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";

export const slugify = (str: string) => {
  return String(str)
    .normalize("NFKD") // split accented characters into their base characters and diacritical marks
    .replace(/[\u0300-\u036f]/g, "") // remove all the accents, which happen to be all in the \u03xx UNICODE block.
    .trim() // trim leading or trailing whitespace
    .toLowerCase() // convert to lowercase
    .replace(/[^a-z0-9 -]/g, "") // remove non-alphanumeric characters
    .replace(/\s+/g, "-") // replace spaces with hyphens
    .replace(/-+/g, "-"); // remove consecutive hyphens
};

export const toUnicodeLocale = (locale: string) => {
  const defaultRegexp = "^[a-z]{2}(-[A-Z]{0,2})?$";
  const defaultLocale = new RegExp(defaultRegexp);
  if (Object.keys(supportedLang).includes(locale)) {
    // If it's a supported language, append "-ae" to avoid craching
    locale = `${locale}-ae`;
  }
  if (!defaultLocale.test(locale)) {
    const insensitiveLocale = new RegExp(defaultRegexp, "i");
    if (insensitiveLocale.test(locale)) {
      const availableLocale = locale.split("-");
      const newLocale = `${availableLocale[0].toLowerCase()}-${availableLocale[1].toUpperCase()}`;
      return newLocale;
    }
  }
  return locale;
};
//array intersection
/**
 * let intersection = arrA.filter(x => arrB.includes(x));
 */
export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function encodeUrlIfNeeded(url: string) {
  if (url && decodeURIComponent(url) === url) {
    return encodeURIComponent(url);
  }
  return url;
}

export function getMaskedCard(summary: string) {
  return `**** **** **** ${summary}`;
}
type AnyObject = { [key: string]: any };
export function trimObjectProperties<T>(obj: T): T {
  if (typeof obj === "string") {
    return obj.trim() as T; // Trim strings directly
  } else if (Array.isArray(obj)) {
    return obj.map(trimObjectProperties) as T; // Recursively process arrays
  } else if (obj !== null && typeof obj === "object") {
    const trimmedObject: AnyObject = {};
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        trimmedObject[key] = trimObjectProperties(obj[key]); // Recursively process each property
      }
    }
    return trimmedObject as T;
  }
  return obj; // Return non-string, non-object values as-is
}
